// extracted by mini-css-extract-plugin
module.exports = {"title":"xJomvVUKrDFSE_TeAUJnc"};